import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { Growl } from 'primereact/growl';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import servicioLayout from '../servicios/ServicioLayout';
import servicioDescargaArchivos from '../servicios/ServicioArchivos';
import logo_upload from '../../../src/imagen/IconUpload.png'

export class FacturacionLayout extends Component {
  constructor() {
    super();
    this.state = {
      files:{},
      mostrarModalResultado:false,
      listaResultados:[],
      botonFacturacion:false,
      listaFacturacion:[],
      mostrarModalFacturacion:false,
      listaObjetos:[]

    }
  }

  onDrop = (files) => {
    
    let formData = new FormData();
    formData.append('layout',files[0]);
    servicioLayout.procesar_layout(formData).then(response=>{
      let respuesta = response.data;
      let listaResultados = respuesta.lista;
      this.setState({listaResultados:listaResultados,mostrarModalResultado:true})

      for (let i = 0; i < listaResultados.length; i++) {
            if(listaResultados[i].error){
              this.setState({botonFacturacion:listaResultados[i].error});
              break;
            }
      }
      var listaObjetos=[];
      for (let i = 0; i < listaResultados.length; i++) {
        listaObjetos.push(listaResultados[i].objeto);
       }
       this.setState({listaObjetos:listaObjetos});
    })
  };

  cerrarModalResultados=()=>{
    this.setState({mostrarModalResultado:false,botonFacturacion:false})
  }

  columna_mensaje=(rowData, column)=>{
    if(rowData.mensaje!=null)
    return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>{rowData.mensaje}</p>;
  }

  facturar_layout=()=>{
    let {listaObjetos}=this.state;
    servicioLayout.facturar_layout(listaObjetos).then(response=>{
      let respuesta = response.data;
      let listaFacturacion = respuesta.lista;
      this.setState({listaFacturacion:listaFacturacion,mostrarModalFacturacion:true,mostrarModalResultado:false,listaResultados:[],botonFacturacion:false})
    })
  }

  cerrarModalFacturacion=()=>{
    this.setState({mostrarModalFacturacion:false,botonFacturacion:false})
  }

  templateDescargaArchivos = (rowData, column) => {
    if (rowData.error === true)
     return  <p> </p>
    else
     return <Button type="button" icon="pi-md-cloud-download" className="p-button-success" onClick={(e) => this.descargaArchivos(rowData)}></Button>
  }

  descargaArchivos = (rowData) => {
    servicioDescargaArchivos.descargaArchivo("documentos/descargar_documentos_layout.json", { uuid: rowData.objeto.uuid });
  }

  templateErrorResultado = (rowData, column) => {
    if (rowData.error === true)
        return <div className="p-col-12 p-md-2"><i className="pi-md-cancel"></i></div>;
    else
        return <div className="p-col-12 p-md-2"><i className="pi-md-check-circle"></i></div>;
}



  render() {

    let {mostrarModalResultado,listaResultados,botonFacturacion,listaFacturacion,mostrarModalFacturacion}=this.state;

    const piePaginaModalRestultados = (
      <div>
        {botonFacturacion===true ? "":<Button icon="pi-md-check" onClick={this.facturar_layout} label="Facturar" className="teal-btn flat-btn" />}
        <Button label="Cerrar" icon="pi pi-times" onClick={this.cerrarModalResultados} />
      </div>
    );

    const piePaginaModalFacturacion = (
      <div>
        <Button label="Cerrar" icon="pi pi-times" onClick={this.cerrarModalFacturacion} />
      </div>
    );


    return (
      <div>
        <Growl ref={(el) => this.growl = el} />
        <div className="card card-w-title">
          <h1>Cargar layout .XLSX para facturación</h1>
        </div>

        <div className="card card-w-title" style={{marginBottom:'50px'}}>
        <Dropzone accept=".xlsx" onDrop={this.onDrop}>
            {({ getRootProps, getInputProps }) => (
              <section className="container container__center">
                <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                  <input   {...getInputProps()} />
                  <img className="rectangulo-img-upload" src={logo_upload} alt='upload'/>
                  <p className="rectangulo-p-upload">Arrastra y suelta aquí los archivos .xlsx para validarlos</p>
                </div>
              </section>
            )}
          </Dropzone>
        </div>

        <Dialog header="Información Procesada" visible={mostrarModalResultado} style={{ width: '70vw' }} modal={true} closeOnEscape={false} closable={false} footer={piePaginaModalRestultados} onHide={this.cerrarModalResultados}>
        <DataTable value={listaResultados} header="Facturas generadas" responsive={true}>
          <Column field="objeto.layoutWrapper.comprobante.emisor.rfc" header="R.F.C Emisor" />
          <Column field="objeto.layoutWrapper.comprobante.emisor.nombre" header="Nombre Emisor"/>
          <Column field="objeto.layoutWrapper.comprobante.receptor.rfc" header="R.F.C Receptor"/>
          <Column field="objeto.layoutWrapper.comprobante.receptor.nombre" header="Nombre Receptor"/>
          <Column body={this.columna_mensaje} header="Observacion"/>
         </DataTable>
      </Dialog>

      <Dialog header="Resultado facturación" visible={mostrarModalFacturacion} style={{ width: '50vw' }} modal={true} closeOnEscape={false} closable={false} footer={piePaginaModalFacturacion} onHide={this.cerrarModalFacturacion}>
        <DataTable value={listaFacturacion} header="Facturas generadas" responsive={true}>
          <Column body={this.templateErrorResultado} header="Estado" />
          <Column field="mensaje" header="Observación" />
          <Column field="objeto.uuid" header="UUID" />
          <Column field="objeto.serie" header="Serie" />
          <Column field="objeto.folio" header="Folio" />
          <Column body={this.templateDescargaArchivos} style={{ textAlign: 'center', width: '8em' }} header="Descargar archivos" />
        </DataTable>
      </Dialog>

      </div>)
  }
}